import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { PageTitle } from '../../../../../_metronic/layout/core';
import ExcepcionGarantiaInfo from '../../../../Components/Garantias/ExcepcionGarantiaInfo';
import { GetGarantiaDetalleFullById } from '../../../../api/Api';


export default function ViewExcepcionGarantia() {
  const { id } = useParams();

  const {
    data: exceptionInfoQuery,
    isFetching: isFetchingExceptionInfo
  } = useQuery(["initDataException", id], async ({ queryKey }) => {
    try {
      const id = queryKey[1];
      let result = null;
      result = await GetGarantiaDetalleFullById(id);
      return {
        garantia: result.data.garantia,
        detalleGarantia: result.data.detalle_garantia,
      };
    } catch (error) {
      console.log(error);
    }
  }, {
    enabled: !!id
  });


  const breadcrumbs = [
    { title: "Inicio", path: "/dashboard", isActive: true, isSeparator: false },
    { title: "", path: "", isActive: false, isSeparator: true },
    { title: "Garantías", path: "", isActive: false, isSeparator: false },
    { title: "", path: "", isActive: false, isSeparator: true },
    { title: "Revisión de Garantías", path: "/garantias/listado_garantias_excepcion", isActive: false, isSeparator: false },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Visualización de Excepción</PageTitle>
      <div className='max-width-xl-900'>
        <ExcepcionGarantiaInfo garantiaInfo={exceptionInfoQuery} isLoading={isFetchingExceptionInfo}></ExcepcionGarantiaInfo>
      </div>
    </>
  )
}